<template>
  <div id="sfl">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('information.fileName')" >
                <el-input v-model="filterForm.fileName" :placeholder="$t('information.enterFileName')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('information.createTime')" >
                <el-date-picker
                  v-model="filterForm.createTime"
                  type="daterange"
                  range-separator="-"
                  :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                  align="right">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="20">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="filterBtns">
                  <el-upload
                    v-show="false"
                    class="upload-demo"
                    :action="attachmentsUploadUrl"
                    :limit="1"
                    :file-list="fileList"
                    :on-success="onSuccess"
                    :on-remove="onRemove"
                    :headers="header"
                    accept=".pdf"
                    :before-upload="onStart"
                    :on-error="onError"
                    >
                    <div ref="importFile">111</div>
                  </el-upload>
                  <el-button type="primary" @click="$refs.importFile.click()" >{{ $t('upload') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" v-loading="tableLoading">
              <el-table-column sortable prop="fileName" :label="$t('information.fileName')"></el-table-column>
              <el-table-column sortable prop="createTime" :label="$t('information.createTime')"></el-table-column>
              <el-table-column :label="$t('operation')">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="downloadSfl(scope.row.fileUrl)">{{ $t('download') }}</el-button>
                  <el-button type="text" size="mini" @click="deleteSfl(scope.row.id)">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Popup',
  components: {
  },
  data: function () {
    return {
      header: {
        token: CookieManage.get('token') || '', // 用户token
      },
      fileForm: {
        fileName: '',
      },
      filterForm: {
        fileName: '', // 文件名称
        createTime: [], // 创建时间
      },
      initFilterForm: {
        fileName: '', // 文件名称
        createTime: [], // 创建时间
      },
      loading: false,
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      fileList: [],
      tableLoading: false,
      attachmentsUploadUrl: window.uploadUrl,
      fullscreenLoading: false
    }
  },
  mounted () {

  },

  methods: {
    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },

    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      this.filterForm.startDate = this.filterForm.createTime[0] || ''
      this.filterForm.endDate = this.filterForm.createTime[1] || ''
      let res = await window.instance.post(window.retailinkUrl + '/slf2Check/listSlf2Check', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    downloadSfl: function(fileUrl) {
      window.open(fileUrl)
    },

    // 开始上传文件的回调
    onStart() {
      this.fullscreenLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    onError() {
      this.fullscreenLoading.close();
    },
    // 成功上传文件的回调
    onSuccess(response, file, fileList) {
      console.log('response', response)
      console.log('file', file)
      console.log('fileList', fileList)
      this.addSFL(file.response.data.url)
      this.fullscreenLoading.close();
    },

    // 添加sfl
    async addSFL(url) {
      let res = await window.instance.post(window.retailinkUrl + '/slf2Check/saveSlf2Check', {fileUrl: url})
      res = res.data
      if (res.code === 200) {
        this.onSearch(true)
        this.fileList = []
        this.$message.success(res.message)
      }
    },
    // 删除文件的回调
    onRemove(file, fileList) {
      // todo: 删除文件
      console.log('删除')
    },
    deleteSfl: function(id) {
      // 删除
      this.$confirm('确定删除吗?', '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await window.instance.post(window.retailinkUrl + '/slf2Check/delSlf2Check/' + id)
        res = res.data
        if (res.code === 200) {
          this.onSearch(true)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },
  }
}
</script>

<style scoped lang="sass">
#sfl

</style>



// WEBPACK FOOTER //
// src/pages/information/sfl.vue